import config from "@/data/config";

const env = {
  getters: {
    isDebugMode() {
      return import.meta.env.VITE_DEBUG === "true";
    },
    useAuth() {
      return import.meta.env.VITE_DO_AUTH === "true";
    },
    useDatastore() {
      return import.meta.env.VITE_USE_DATASTORE === "true";
    },
    useLandingPage() {
      return config.settings.useLandingPage === true;
    },
    useNavbar() {
      return config.settings.useNavbar === true;
    },
    publicKey(state, getters) {
      let key = import.meta.env.VITE_PUBLIC_KEY;

      key =
        getters.isDebugMode && import.meta.env.VITE_USE_DATASTORE === "true"
          ? `9${key}`
          : key;

      return key;
    }
  }
};

export default env;
